export default __webpack_public_path__ + "static/media/short_notes.93578784.png";